<script setup lang="ts">
import WebinarMelding from "@/modules/public/views/home/components/WebinarMelding.vue";
import { isVlaams } from "@/utils/isVlaams";
</script>

<template>
  <section id="call-for-action" class="bg-grey-darken-3 text-white">
    <v-container class="py-8" style="max-width: 80rem">



      <v-row v-if="isVlaams()" align="center" justify="center" class="pt-6">
        <v-col
          class="text-h4 font-weight-light text-center text-lg-left"
          cols="12"
          lg="8"
        >
          <h4 class="font-weight-medium">Vraag een gratis demo aan!</h4>
          <p class="text-subtitle-1 pt-2">
            Probeer de Vlaamse versie nu twee maanden gratis uit
          </p>
        </v-col>
        <v-col
          class="text-h4 font-weight-light text-center text-lg-left"
          cols="12"
          lg="4"
        >
          <v-btn
            :block="$vuetify.display.lgAndUp"
            class="mx-lg-5"
            size="x-large"
            :to="{ name: 'aanvraagformulier' }"
          >
            Vraag Gratis demo aan
          </v-btn>
        </v-col>
      </v-row>
      <WebinarMelding />
    </v-container>
  </section>
</template>
